import Logger from "../../../common/util/Logger";
import { CHANGE_TYPE_CHANGED } from "./updateChangesTypes.action";
import { SET_CHANGE_TYPES } from "./setChangeType.action";
import { AnyAction, IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { ChangesType } from "../../types";
import { updateObject } from "../../../common/util/UpdateObject";

const logger = new Logger("updateChangeTypeReducer");

export const updateChangeTypeReducer: IPartialReducer<ChangesType> = (state, action: AnyAction) => {
    switch (action.type) {
        case CHANGE_TYPE_CHANGED: {
            let newChangeType = [...state.changeType.changeType];

            if (action.value) {
                if (!newChangeType.includes(action.changeType)) {
                    newChangeType.push(action.changeType);
                }
            } else {
                if (newChangeType.includes(action.changeType)) {
                    newChangeType = newChangeType.filter((value) => value !== action.changeType);
                }
            }

            logger.info("Change Type changed to: " + newChangeType);

            return updateObject(state, { changeType: { changeType: newChangeType } });
        }
        case SET_CHANGE_TYPES: {
            return updateObject(state, { changeType: { changeType: action.changeTypes } });
        }
        default:
            if (!state) {
                return {};
            }
            return state;
    }
};
